/* ============================================================
   tio-header.js - Logica del header global
   Portado de diseno/previews/te-header.jsx (React -> vanilla).
   Ver Header.spec.md.

   Cubre: compactacion por scroll, hamburguesa <-> X, drawer movil
   con submenu, dropdown desktop, coreografia de paneles, swipe para
   cerrar, scroll-lock y senal global que oculta el FAB de WhatsApp.

   Doctrina 8.1: listeners DELEGADOS en document, para sobrevivir al
   DOM re-renderizado por Dawn (secciones AJAX).
   ============================================================ */
(function () {
  'use strict';

  var teh = document.querySelector('[data-tio-header]');
  var drawer = document.querySelector('[data-tio-drawer]');
  var scrim = document.querySelector('[data-tio-scrim]');
  if (!teh || !drawer) return;

  var raiz = document.documentElement;
  var menuAbierto = false;
  var pillTimer = null;

  var reduce = typeof matchMedia === 'function' &&
    matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Se esconde al bajar y vuelve al subir (4-oct-2026) ----------
     Pedido del dueno, mirando decantslab.cl: "cuando uno escrollea hacia
     abajo, el header se oculta... mientras la etiqueta del Cyber queda
     fija". En decantslab el header se va con la pagina y no vuelve hasta
     llegar arriba; aca vuelve apenas se sube un poco, para no dejar al
     cliente sin menu ni carrito a mitad de pagina.
     Umbrales: en los primeros 120 px nunca se esconde; para esconderse hay
     que bajar 24 px seguidos y para volver, subir 56. Asi un dedo que
     tiembla o el rebote de iOS no la hacen parpadear.
     El estilo vive en tio-header.css (.teh[data-oculto="1"]). */
  var BAJA = 24, SUBE = 56, ARRIBA = 120;
  var VUELTA = 440;  /* lo que dura la vuelta (420 ms en tio-header.css) + margen */
  var tramo = 0;   /* recorrido seguido en la misma direccion: + baja, - sube */
  var volverT = 0;
  /* Estados de data-oculto: "1" escondida · "volviendo" bajando a su
     lugar con su propia curva · "0" (o sin atributo) en su lugar. */
  function ocultar(si) {
    var actual = teh.dataset.oculto || '0';
    if (si) {
      clearTimeout(volverT);
      if (actual !== '1') teh.dataset.oculto = '1';
      return;
    }
    if (actual === '1') {
      teh.dataset.oculto = 'volviendo';
      clearTimeout(volverT);
      volverT = setTimeout(function () {
        if (teh.dataset.oculto === 'volviendo') teh.dataset.oculto = '0';
      }, VUELTA);
    }
  }
  /* La usan los paneles de aca y el vuelo al carrito (tio-fly.js): el
     frasco tiene que aterrizar en un carrito a la vista. */
  window.tioHeaderMostrar = function () { tramo = 0; ocultar(false); };
  /* Navegando con teclado, el foco nunca queda en un header escondido. */
  teh.addEventListener('focusin', function () { window.tioHeaderMostrar(); });

  /* ---------- Coreografia de paneles (Header.spec, seccion Coreografia)
     El pill y un panel NUNCA estan en pantalla a la vez. Al abrir, el pill
     se oculta YA. Al cerrar, vuelve recien a los 200ms (~85% de la salida
     del panel). Reabrir a mitad del cierre cancela el timer: sin parpadeo. */
  function sincronizarPill() {
    clearTimeout(pillTimer);
    if (menuAbierto) {
      teh.dataset.hide = '1';
      raiz.dataset.tehPanel = '1';
    } else {
      pillTimer = setTimeout(function () {
        teh.dataset.hide = '0';
        /* El FAB de WhatsApp es el ULTIMO en volver: se libera junto al pill. */
        raiz.dataset.tehPanel = '';
      }, 200);
    }
  }

  function abrirMenu() {
    if (menuAbierto) return;
    menuAbierto = true;
    window.tioHeaderMostrar();                         /* al cerrar, la pildora vuelve a la vista */
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('is-on');
    teh.dataset.menu = '1';
    document.body.style.overflow = 'hidden';           /* scroll-lock */
    var b = document.querySelector('[data-tio-menu-toggle]');
    if (b) { b.setAttribute('aria-expanded', 'true'); b.setAttribute('aria-label', 'Cerrar menú'); }
    /* Remonta el bloque social para re-disparar el sheen UNA vez (nunca en loop). */
    var soc = drawer.querySelector('[data-tio-social]');
    if (soc && !reduce) { var p = soc.parentNode; p.replaceChild(soc.cloneNode(true), soc); }
    sincronizarPill();
  }

  function cerrarMenu() {
    if (!menuAbierto) return;
    menuAbierto = false;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.style.transform = '';                        /* limpia el drag */
    if (scrim) scrim.classList.remove('is-on');
    teh.dataset.menu = '0';
    document.body.style.overflow = '';
    var b = document.querySelector('[data-tio-menu-toggle]');
    if (b) { b.setAttribute('aria-expanded', 'false'); b.setAttribute('aria-label', 'Abrir menú'); }
    sincronizarPill();
  }

  /* ---------- Compactacion y escondida por direccion de scroll ----------
     Histeresis de 5px para que no parpadee. rAF + passive.
     La pildora es fixed: animar su alto NO reflowea el documento
     (excepcion deliberada y acotada, Header.spec nota 60fps).
     La posicion se acota a [0, fin de pagina]: el rebote elastico de iOS
     arriba y abajo no cuenta como "subir" ni "bajar". */
  var ultimaY = window.scrollY, raf = 0;
  window.addEventListener('scroll', function () {
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = 0;
      var tope = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      var y = Math.min(Math.max(0, window.scrollY), tope);
      var dy = y - ultimaY;
      if (Math.abs(dy) < 5) return;
      if (menuAbierto || busquedaAbierta) { teh.dataset.compact = '0'; tramo = 0; ultimaY = y; return; }
      if (dy > 0 && y > 72) teh.dataset.compact = '1';
      else if (dy < 0 || y <= 72) teh.dataset.compact = '0';

      if (y <= ARRIBA) { tramo = 0; ocultar(false); }
      else {
        if (tramo !== 0 && (dy > 0) !== (tramo > 0)) tramo = 0;   /* cambio de direccion */
        tramo += dy;
        if (tramo >= BAJA) ocultar(true);
        else if (tramo <= -SUBE) ocultar(false);
      }
      ultimaY = y;
    });
  }, { passive: true });

  /* ---------- Listeners delegados (doctrina 8.1) ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-tio-menu-toggle]')) {
      menuAbierto ? cerrarMenu() : abrirMenu();
      return;
    }
    if (e.target.closest('[data-tio-menu-close]') || e.target.closest('[data-tio-scrim]')) {
      cerrarMenu();
      return;
    }
    /* Submenu del drawer movil. El CSS lo abre con
       .teh-mi > button[aria-expanded="true"] + .teh-sub, es decir por el
       ATRIBUTO y no por una clase: basta con alternar aria-expanded. */
    var sub = e.target.closest('[data-tio-sub-toggle]');
    if (sub) {
      var abierto = sub.getAttribute('aria-expanded') === 'true';
      sub.setAttribute('aria-expanded', abierto ? 'false' : 'true');
      return;
    }
    /* Dropdown desktop */
    var drop = e.target.closest('[data-tio-drop-toggle]');
    if (drop) {
      var item = drop.closest('[data-tio-drop]');
      var ab = item.classList.toggle('is-open');
      drop.setAttribute('aria-expanded', ab ? 'true' : 'false');
      return;
    }
    /* Click fuera cierra el dropdown desktop */
    var abiertos = document.querySelectorAll('[data-tio-drop].is-open');
    for (var i = 0; i < abiertos.length; i++) {
      if (!abiertos[i].contains(e.target)) {
        abiertos[i].classList.remove('is-open');
        var bt = abiertos[i].querySelector('[data-tio-drop-toggle]');
        if (bt) bt.setAttribute('aria-expanded', 'false');
      }
    }
  });

  /* Escape cierra menu y dropdowns */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    cerrarMenu();
    cerrarBusqueda();
    var abiertos = document.querySelectorAll('[data-tio-drop].is-open');
    for (var i = 0; i < abiertos.length; i++) abiertos[i].classList.remove('is-open');
  });

  /* ---------- Dropdown desktop por hover, con gracia de 140ms ---------- */
  var graciaT = null;
  document.addEventListener('mouseover', function (e) {
    var item = e.target.closest('[data-tio-drop]');
    if (!item) return;
    if (!matchMedia('(min-width: 900px)').matches) return;
    clearTimeout(graciaT);
    item.classList.add('is-open');
    var bt = item.querySelector('[data-tio-drop-toggle]');
    if (bt) bt.setAttribute('aria-expanded', 'true');
  });
  document.addEventListener('mouseout', function (e) {
    var item = e.target.closest('[data-tio-drop]');
    if (!item) return;
    if (!matchMedia('(min-width: 900px)').matches) return;
    /* No cerrar si el puntero sigue dentro del item */
    if (e.relatedTarget && item.contains(e.relatedTarget)) return;
    clearTimeout(graciaT);
    graciaT = setTimeout(function () {
      item.classList.remove('is-open');
      var bt = item.querySelector('[data-tio-drop-toggle]');
      if (bt) bt.setAttribute('aria-expanded', 'false');
    }, 140);
  });

  /* ---------- Swipe hacia la izquierda para cerrar el drawer ----------
     Sigue el dedo con translateX. Suelta a < -70px o velocidad > 0.45 px/ms
     => cierra; si no, vuelve con spring. */
  var arrastre = null;
  drawer.addEventListener('pointerdown', function (e) {
    if (!menuAbierto || e.pointerType === 'mouse') return;
    arrastre = { x0: e.clientX, t0: e.timeStamp, dx: 0, activo: false };
  });
  drawer.addEventListener('pointermove', function (e) {
    if (!arrastre) return;
    var dx = e.clientX - arrastre.x0;
    if (!arrastre.activo && Math.abs(dx) < 8) return;
    arrastre.activo = true;
    arrastre.dx = Math.min(0, dx);                       /* solo hacia la izquierda */
    drawer.style.transition = 'none';
    drawer.style.transform = 'translateX(' + arrastre.dx + 'px)';
  });
  function soltar(e) {
    if (!arrastre) return;
    var dx = arrastre.dx;
    var v = Math.abs(dx) / Math.max(1, e.timeStamp - arrastre.t0);
    arrastre = null;
    drawer.style.transition = '';
    drawer.style.transform = '';
    if (dx < -70 || v > 0.45) cerrarMenu();
  }
  drawer.addEventListener('pointerup', soltar);
  drawer.addEventListener('pointercancel', soltar);

  /* ============================================================
     OVERLAY DE BUSQUEDA (T-21)
     El form es real (action="/search"): sin JS la busqueda funciona.
     Todo esto es mejora progresiva encima.
     ============================================================ */
  var ov = document.querySelector('[data-tio-search-ov]');
  var busquedaAbierta = false;

  function abrirBusqueda() {
    if (!ov || busquedaAbierta) return;
    busquedaAbierta = true;
    window.tioHeaderMostrar();                         /* al cerrar, la pildora vuelve a la vista */
    ov.classList.add('is-open');
    ov.setAttribute('aria-hidden', 'false');
    teh.dataset.search = '1';
    document.body.style.overflow = 'hidden';
    clearTimeout(pillTimer);
    teh.dataset.hide = '1';
    raiz.dataset.tehPanel = '1';
    /* autofocus ~180ms: en movil sube el teclado recien montado el panel */
    setTimeout(function () {
      var inp = ov.querySelector('[data-tio-search-input]');
      if (inp) inp.focus();
    }, 180);
  }

  function cerrarBusqueda() {
    if (!ov || !busquedaAbierta) return;
    busquedaAbierta = false;
    ov.classList.remove('is-open');
    ov.setAttribute('aria-hidden', 'true');
    ov.querySelector('[data-tio-search-panel]').style.transform = '';
    teh.dataset.search = '0';
    if (!menuAbierto) document.body.style.overflow = '';
    sincronizarPill();
  }

  function pintarResultados(html) {
    var caja = ov.querySelector('[data-tio-search-resultados]');
    var inicial = ov.querySelector('[data-tio-search-inicial]');
    if (html === null) {
      caja.hidden = true; caja.innerHTML = '';
      if (inicial) inicial.hidden = false;
      return;
    }
    if (inicial) inicial.hidden = true;
    caja.hidden = false;
    caja.innerHTML = html;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fila(p, i) {
    var img = p.image
      ? '<img src="' + esc(p.image) + '" alt="" width="64" height="64" loading="lazy" decoding="async">'
      : '';
    var marca = p.vendor && p.vendor !== 'Tio Elixir' ? esc(p.vendor) : '';
    var precio = p.price != null && p.price !== '' ? '<div class="teh-ri__price"><span>Desde</span>' + esc(p.price) + '</div>' : '';
    return '<a class="teh-row-item" href="' + esc(p.url) + '" style="--ri: ' + i + '">' +
      '<div class="teh-ri__thumb">' + img + '</div>' +
      '<div class="teh-ri__tx"><div class="teh-ri__name">' + esc(p.title) + '</div>' +
      '<div class="teh-ri__sub"><span class="teh-ri__brand">' + marca + '</span></div></div>' +
      precio + '</a>';
  }

  var debounce = null, ctrl = null;
  function buscar(q) {
    if (!q) { pintarResultados(null); return; }
    if (ctrl) ctrl.abort();
    ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=7';
    fetch(url, ctrl ? { signal: ctrl.signal } : undefined)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var prods = (((d.resources || {}).results || {}).products) || [];
        if (!prods.length) {
          pintarResultados(
            '<div class="teh-empty">' +
            '<div class="teh-empty__ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.2-3.2"/></svg></div>' +
            '<p class="teh-empty__t">No encontramos “' + esc(q) + '”</p>' +
            '<p class="teh-empty__s">Prueba con otra fragancia o marca.</p>' +
            '<a class="teh-empty__cta" href="/collections/todos-los-productos">Ver todo el catálogo</a>' +
            '</div>');
          return;
        }
        var n = prods.length;
        pintarResultados(
          '<div class="teh-results"><span class="teh-search-lbl">' + n +
          ' resultado' + (n > 1 ? 's' : '') + '</span>' +
          prods.map(fila).join('') + '</div>');
      })
      .catch(function (e) { if (e && e.name !== 'AbortError') pintarResultados(null); });
  }

  if (ov) {
    /* Abrir: lupa de la pildora y del drawer. El href a /search queda como
       fallback sin JS, por eso se hace preventDefault aca. */
    document.addEventListener('click', function (e) {
      var lupa = e.target.closest('[data-tio-search-open]');
      if (lupa) {
        e.preventDefault();
        if (lupa.hasAttribute('data-tio-handoff') && menuAbierto) {
          /* Handoff menu -> busqueda: el pill sigue oculto todo el traspaso. */
          cerrarMenu();
          clearTimeout(pillTimer);
          teh.dataset.hide = '1';
          raiz.dataset.tehPanel = '1';
          setTimeout(abrirBusqueda, 140);
        } else {
          abrirBusqueda();
        }
        return;
      }
      if (e.target.closest('[data-tio-search-close]')) { cerrarBusqueda(); return; }
      /* Tap fuera del panel (en el scrim) cierra */
      if (busquedaAbierta && e.target === ov) { cerrarBusqueda(); return; }

      var limpiar = e.target.closest('[data-tio-search-clear]');
      if (limpiar) {
        var inp = ov.querySelector('[data-tio-search-input]');
        inp.value = ''; inp.focus();
        limpiar.hidden = true;
        pintarResultados(null);
        return;
      }
      var chip = e.target.closest('[data-tio-chip]');
      if (chip) {
        var i2 = ov.querySelector('[data-tio-search-input]');
        i2.value = chip.getAttribute('data-tio-chip');
        i2.dispatchEvent(new Event('input', { bubbles: true }));
        i2.focus();
      }
    });

    ov.addEventListener('input', function (e) {
      var inp = e.target.closest('[data-tio-search-input]');
      if (!inp) return;
      var q = inp.value.trim();
      var btn = ov.querySelector('[data-tio-search-clear]');
      if (btn) btn.hidden = q === '';
      clearTimeout(debounce);
      debounce = setTimeout(function () { buscar(q); }, 200);
    });

    /* Swipe-down para cerrar SOLO desde el grabber: la lista scrollea sin
       disparar el cierre (Header.spec, Scroll vs cierre). */
    var grab = ov.querySelector('[data-tio-search-grab]');
    var panel = ov.querySelector('[data-tio-search-panel]');
    var arrastreS = null;
    if (grab && panel) {
      grab.addEventListener('pointerdown', function (e) {
        arrastreS = { y0: e.clientY, dy: 0 };
        grab.setPointerCapture(e.pointerId);
      });
      grab.addEventListener('pointermove', function (e) {
        if (!arrastreS) return;
        arrastreS.dy = Math.min(0, e.clientY - arrastreS.y0) * -1;
        var d = Math.max(0, e.clientY - arrastreS.y0);
        panel.style.transition = 'none';
        panel.style.transform = 'translateY(' + d + 'px)';
        arrastreS.dy = d;
      });
      var soltarS = function () {
        if (!arrastreS) return;
        var d = arrastreS.dy;
        arrastreS = null;
        panel.style.transition = '';
        panel.style.transform = '';
        if (d > 70) cerrarBusqueda();
      };
      grab.addEventListener('pointerup', soltarS);
      grab.addEventListener('pointercancel', soltarS);
    }
  }

  /* ---------- Contador del carrito ----------
     Se actualiza con item_count REAL. El bounce es el mismo del sistema
     que dispara el fly-to-cart al aterrizar (Header.spec, Contador). */
  window.tioActualizarCarrito = function (n) {
    var boton = document.querySelector('[data-tio-cart]');
    if (!boton) return;
    var badge = boton.querySelector('[data-tio-cart-count]');

    /* Con carrito vacio el badge NO existe en el DOM (igual que el diseno).
       Si el carrito pasa de 0, se crea; si vuelve a 0, se elimina. */
    if (n <= 0) { if (badge) badge.remove(); return; }
    var antes = 0;
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'teh-count';
      badge.setAttribute('data-tio-cart-count', '');
      boton.appendChild(badge);
    } else {
      antes = parseInt(badge.textContent, 10) || 0;
    }
    badge.textContent = n;
    if (n > antes && !reduce) {
      badge.classList.remove('is-pop');
      void badge.offsetWidth;                            /* reinicia la animacion */
      badge.classList.add('is-pop');
    }
  };
})();

/* ============================================================
   4-oct-2026 · DEGRADES QUE FLUYEN DENTRO DE UN TEXTO: SOLO MIENTRAS SE VEN.
   El dueno: "las animaciones... se perdieron... se ve relageado". Medido en
   la ficha (Chromium, CPU 4x mas lenta, 3 s quieto con la pagina bajada):
   el titulo "Notas" con su degrade en movimiento obligaba a repintar en
   cada cuadro, aunque estuviera fuera de la pantalla, y con eso el hilo
   principal pasaba 2.116 ms ocupado; sin el, 679 ms. Ese hilo es el que
   mueve el check de "Agregar", el formato elegido y la pildora flotante.
   Un degrade dentro de las letras solo se puede mover con
   background-position, y eso no lo hace el compositor. Hasta el 13-oct-2026
   se pausaba mientras no estaba a la vista (te-anim-quieta); desde ese dia
   hace UNA pasada cada vez que entra en pantalla (te-grad-pasa, en
   tio-home.css y tio-pdp.css) y queda quieto.
   ============================================================ */
(function () {
  if (!('IntersectionObserver' in window)) return;
  var SEL = '.home-title .ac, .why-ac, .home-bigtitle__t, .pdp-sec-title--notes';
  var io = new IntersectionObserver(function (entradas) {
    /* 13-oct-2026: ya no se pausa un bucle; al entrar en pantalla el
       degradado hace UNA pasada (.te-grad-pasa) y al salir se le quita la
       clase, para que la proxima vez que aparezca la haga de nuevo. Medido:
       arriba en el inicio el hilo principal pasa de 2.811 ms ocupado cada
       3 s (CPU 4x) a quedar libre apenas termina la pasada. */
    entradas.forEach(function (e) { e.target.classList.toggle('te-grad-pasa', e.isIntersecting); });
  });
  function observar() {
    document.querySelectorAll(SEL).forEach(function (el) {
      if (el._tioQuieta) return;
      el._tioQuieta = true;
      io.observe(el);
    });
  }
  observar();
  document.addEventListener('shopify:section:load', observar);
})();
